import styled, { css } from 'styled-components';
import { BodyMedBold, BodySmBold, BodySmReg } from '@seed-health/tokens';

const inheritType = css`
  font: inherit;
  letter-spacing: inherit;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: var(--spacing-24) 0;
  border-radius: var(--radius-xl);
  background-color: var(--fill-tertiary);
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: center;
  padding: var(--spacing-8);
`;

export const Toggle = styled.div`
  display: flex;
  padding: var(--spacing-4);
  border-radius: var(--radius-full);
  background-color: var(--color-primary-seed-green-10);
`;

export const ToggleButton = styled.button<{ $selected: boolean }>`
  ${BodySmBold};
  position: relative;
  padding: var(--spacing-4) var(--spacing-16);
  border: 0;
  border-radius: var(--radius-full);
  background-color: ${({ $selected }) =>
    $selected ? 'var(--fill-primary)' : 'transparent'};
  color: var(--text-primary);
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  /* Extends the hit area to 44px tall without changing the pill */
  &::before {
    content: '';
    position: absolute;
    inset: calc(-1 * var(--spacing-8)) 0;
  }

  &:hover {
    opacity: var(--hover);
  }

  &:active {
    opacity: var(--active);
  }

  &:focus-visible {
    opacity: var(--focused);
    outline: 3px solid var(--focus-color, currentColor);
    outline-offset: 2px;
  }
`;

export const Highlight = styled.span<{ $tall?: boolean }>`
  ${inheritType};
  background: linear-gradient(var(--guidance-primary), var(--guidance-primary))
    center / 100% ${({ $tall }) => ($tall ? '75%' : '65%')} no-repeat;
  padding: 0 2px;
  margin: ${({ $tall }) => ($tall ? '0' : '0 -2px')};
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
  padding: 0 var(--spacing-8) var(--spacing-8);

  a {
    width: 100%;
  }
`;

export const Content = styled.div`
  padding: var(--spacing-8) var(--spacing-16) 0;
`;

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--spacing-8);
`;

export const PlanTitle = styled.p`
  ${BodyMedBold};
  color: var(--text-primary);
`;

export const PlanPrice = styled.p`
  ${BodyMedBold};
  color: var(--text-primary);
  white-space: nowrap;
`;

export const Body = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--spacing-8);
`;

export const BodyText = styled.p`
  ${BodySmReg};
  color: var(--text-primary);
`;

export const HighlightedBodyText = styled(BodyText)`
  margin-left: -2px;
`;

export const BodyNote = styled.p`
  ${BodySmReg};
  color: var(--text-secondary);
  white-space: nowrap;
`;

export const StrikePrice = styled(BodyNote)`
  text-decoration-line: line-through;
`;

export const CheckList = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0 0 var(--spacing-8) var(--spacing-16);
  list-style: none;
`;

export const CheckListItem = styled.li`
  ${BodySmReg};
  display: flex;
  align-items: center;
  gap: var(--spacing-8);
  color: var(--text-primary);

  svg {
    flex-shrink: 0;
  }

  > span {
    ${inheritType};
  }
`;
